import { defineStore } from "pinia";
import { errorHandler } from "@/package/helpers/error-handler";
import { apiGetDisableAllPush, apiGetEnablePush } from "@/modules/web-push/api";

export const useWebPushStore = defineStore("web-push-store", {
  state: () => ({}),

  actions: {
    async getEnablePush(fcm_token: string) {
      try {
        return await apiGetEnablePush(fcm_token);
      } catch (e: Error | unknown) {
        errorHandler(e);
        throw e;
      }
    },

    async getDisablePush() {
      try {
        return await apiGetDisableAllPush();
      } catch (e: Error | unknown) {
        errorHandler(e);
        throw e;
      }
    },
  },
});
